/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';

export default {
    name: 'xq',
    components: {ccTab},
    data() {
        return {
            data:{
                pmgg:{images:[]},
                cbxx:[
                    {name:'船籍', value:'', code:'cjgbmTranslateText'},
                    {name:'船籍港', value:'', code:'cjg'},
                    {name:'船舶检验机构', value:'', code:'cbjyjg'},
                    {name:'航区', value:'', code:'hq'},
                    {name:'航体材料', value:'', code:'ctcl'},
                    {name:'总吨', value:'1000吨', code:'zd'},
                    {name:'净吨', value:'', code:'jd'},
                    {name:'总长', value:'', code:'zc'},
                    {name:'船长', value:'', code:'cc'},
                    {name:'船宽', value:'', code:'ck'},
                    {name:'型深', value:'', code:'xs'},
                    {name:'参考载重吨', value:'', code:'ckzzd'},
                    {name:'满载排水量', value:'', code:'mzpsl'},
                    {name:'空载排水量', value:'', code:'kzpsl'},
                    {name:'主机型号', value:'', code:'zjxh'},
                    {name:'主机数量', value:'', code:'zjsl'},
                    {name:'主机总功率', value:'', code:'zjzgl'},
                    {name:'船舶建造厂', value:'', code:'cbjzc'},
                    {name:'建成日期', value:'', code:'jcrq'},
                    {name:'成新率', value:'', code:'cxl'},
                    {name:'鉴定公司', value:'', code:'jdgs'}
                ],
                xgfj:[]
            },
            cbjbxx: {},
            imgIndex:0,
            activeFirst:0,
            bh: '',
            bdlb: '',
            lx: ''
        };
    },
    computed:{
        marginLeft() {
            return `-${this.activeFirst * 148}px`;
        }
    },
    created() {
        this.init();
    },
    methods: {
        // 初始化数据
        init() {
            this.initParam();
            this.getData();
            this.getFj();
        },
        // 初始化参数
        initParam() {
            this.bh = this.$route.query.bh;
            this.lx = this.$route.query.lx;
            this.bdlb = this.$route.query.bdlb;
        },
        // 获取数据
        getData() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.pmxq.replace('{id}', this.bh),
                params: {bdlb: '19'}
            }).then((res) => {
                this.data.pmgg = res.data.pmxx;
                this.data.pmgg.images = res.data.tpdzList;
                this.cbjbxx = res.data.cbjbxx;
            });
        },
        dealMoney(money) {
            if (money) {
                const arr1 = money.toString().split('.');
                const arr2 = arr1[0].split('').reverse();
                const arr3 = [];
                if (arr2.length > 3) {
                    for (let i = 0; i < arr2.length; i++) {
                        arr3.push(arr2[i]);
                        if (i % 3 === 2 && i !== arr2.length - 1) {
                            arr3.push(',');
                        }
                    }
                    arr1[0] = arr3.reverse().join('');
                    return arr1.join('.');
                }
                return money;
            }
        },
        // 获取附件列表
        getFj() {
            window.fdGlobal.ajax({
                methods: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.getFile,
                params: {businessId: this.bh, type: this.lx}
            }).then((res) => {
                if (res.data.length) {
                    const _data = [];
                    res.data.forEach(e => {
                        const zc = {
                            name: e.wjmc,
                            url: e.bh
                        };
                        _data.push(zc);
                    });
                    this.data.xgfj = _data;
                }
            });
        },
        // 下载附件
        downloadFiles(item) {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.common.downloadFile.replace('{id}', item.url),
                contentType: 'application/json;charset=utf-8',
                responseType: 'blob'
            }).then((res) => {
                const binaryData = [];
                const template = res.data;
                binaryData.push(template);
                const blob = new Blob(binaryData);
                // 非IE下载
                if ('download' in document.createElement('a')) {
                    const elink = document.createElement('a');
                    elink.download = item.name;
                    elink.style.display = 'none';
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, item.name);
                }
            });
        },
        // 切换拍卖类型
        changePmlx(code) {
            this.activePmlx = code;
        },
        // 切换筛选条件
        clickSearch(key, key01) {
            this.searchData[key] = key01;
        },
        // 点击跳转详情
        clickXq() {
            this.$router.push('/kypm/xq');
        },
        changeImg(index) {
            this.imgIndex = index;
        },
        clickLeft() {
            if (this.activeFirst !== 0) {
                this.activeFirst--;
            }
        },
        clickRight() {
            if (this.activeFirst < this.data.pmgg.images.length - 4) {
                this.activeFirst++;
            }
        }
    }
};

